import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { CrewsTable } from '@/components/views/Logistics';


export default /*#__PURE__*/_defineComponent({
  __name: 'DriversSection',
  setup(__props) {

const search = ref('');

const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Phone', dataIndex: 'phone', key: 'phone' },
    { title: 'Status', dataIndex: 'status', key: 'status' },
];

const data = [
    { id: 1, name: 'Marko Novak', phone: '+386 41 123 456', status: 'Available' },
    { id: 2, name: 'Janez Horvat', phone: '+386 41 234 567', status: 'On delivery' },
    { id: 3, name: 'Peter Kovač', phone: '+386 41 345 678', status: 'Available' },
];

const filteredData = computed(() => {
    if (!search.value) {
        return data;
    }
    const searchLower = search.value.toLowerCase();
    return data.filter((item) => item.name.toLowerCase().includes(searchLower));
});

return { __sfc: true,search, columns, data, filteredData, CrewsTable }
}

})